import { useRoute } from '@react-navigation/native'
import { useMutation } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { i18n } from '@zet/localization'

import { brandsI18n } from '../../../localization'
import { isPLHLPartner } from '../../../utils/plhlPartnerIds'
import {
  useGetApplicationPartnerId,
  useIsApplicationV2,
} from '../../applicationDetails/hook'
import { useApiAction } from '../../useApiAction'
import { resendOtp } from '../functions/resendOtp'

export const useResendOtp = () => {
  const toast = useToast()
  const { params } = useRoute()
  const { hash } = params ?? {}

  const { stateManagePost, state } = useApiAction()

  const isV2 = useIsApplicationV2(hash)
  const partnerId = useGetApplicationPartnerId(hash)

  return useMutation({
    mutationFn: (props: { hash: string }) => {
      return isPLHLPartner({ partnerId })
        ? stateManagePost({
            event: 'RESEND_OTP',
          })
        : isV2
        ? stateManagePost({
            payload: {
              data: {
                action: 'RESEND',
              },
            },
          })
        : state === 'HDFC_CC_OTP_GENERATE'
        ? stateManagePost({ extras: { event: 'RESEND_OTP' } })
        : resendOtp(props.hash)
    },
    onSuccess: () => {
      toast?.show({
        intent: 'success',
        heading: brandsI18n.t('common.otpResent'),
        hideAfter: 3000,
      })
    },
    onError: () => {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: i18n.t('toastMessages.somethingWentWrong'),
        hideAfter: 3000,
      })
    },
  })
}
